import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { fromUnitsToRem, YodaSpacing, YodaJustifyContent, YodaBorderRadius } from 'yoda-ui/yodaTheme';

export const adminDashboardFormContainerStyle: SxProps<Theme> = {
  width: '100%',
  paddingBottom: YodaSpacing.large,
};

export const adminDashboardFormContainerContentStyle: SxProps<Theme> = {
  marginBottom: fromUnitsToRem(YodaSpacing.large),
  borderRadius: YodaBorderRadius.medium,
};

export const adminDashboardFormContainerActionsStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: YodaJustifyContent.flexEnd,
  gap: YodaSpacing.small,
  bottom: YodaSpacing.xxLarge,
  left: 0,
  right: 0,
};
